import type { RecommendationLayoutSeed } from 'src/pages/Product/functions/recommendationLayoutSeed'
/* Types */
import { tProduct } from 'src/shared/frontendTypes/product'
import type { LandingPageImageAiGenerated } from 'src/functions/landingPageImageAiGenerated'

/* Components */
import Product from './Product'

/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

interface Props {
  product: tProduct
  recommendationsDeferred?: boolean
  recommendationsLayoutSeed?: RecommendationLayoutSeed
  initialVariantKey?: string
  landingPageImageAiGenerated?: LandingPageImageAiGenerated
}

const ProductPage: React.FC<Props> = ({ product, recommendationsDeferred, recommendationsLayoutSeed, initialVariantKey, landingPageImageAiGenerated }:Props) => {
  return <Product key={product.id} {...{ product, recommendationsDeferred, recommendationsLayoutSeed, initialVariantKey, landingPageImageAiGenerated }} />
}

export default ProductPage
